import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ElementRef, Renderer2, HostListener, ViewChildren, QueryList } from '@angular/core';
import { AppFileUpload } from 'src/app/modules/shared/file-upload/file-upload.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ApiServicesService } from '../../services/api-services.service';
import { ReferenceLibraryService } from 'reference-library';
import { MatDialog } from '@angular/material/dialog';
import { ProfilePictureUploadComponent } from 'src/app/modules/shared/profile-picture-upload/profile-picture-upload.component';
import { UploadDocumentService } from "../../../../services/upload-document.service";
import { ToastrService } from 'ngx-toastr';
import { UserRoleService } from '../../../../services/user-role.service';
import { ActivatedRoute, Router, RouterEvent, NavigationEnd, RoutesRecognized } from '@angular/router';
import * as Roles from '../../../../data/constants/roles';
import { BeneficiaryDetails } from 'src/app/data/models/beneficiaryDetails.model';
import { I140FileUploadConfiguration, ImagilityBaseResponse, ReferenceLibrary, acceptedFileTypes } from 'app-models';
import { filter, first, take, takeUntil, pairwise } from 'rxjs/operators';
import { DependentProfileDataService } from "../../services/dependent-profile-data.service";
import { Subject, Subscription } from 'rxjs';
import { DirtyFormGuard, MarkCleanFormAction } from 'dirty-check-store';
import { Store } from '@ngrx/store';
import { HelpVideoOverlayComponent } from '../../../../modules/shared/help-video-overlay/help-video-overlay.component';
import { NotifyBeneficiaryComponent } from '../notify-beneficiary/notify-beneficiary.component';
import { CustomQuestionnaireService } from 'src/app/modules/custom-questionaire/services/custom-questionnaire.service';
import { CustomErrorToastComponent } from 'custom-error-toast';
import { AddBeneficiaryOrMemberComponent } from 'add-beneficiary-or-member';
import { DialogService } from 'primeng/dynamicdialog';

declare var gapi: any;
@Component({
  selector: 'app-complete-profile-landing',
  templateUrl: './profile-landing.component.html',
  styleUrls: ['./profile-landing.component.scss'],

})
export class ProfileLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  displayDocumentPanel: boolean = false;
  benefirstAndLastName = '';
  userTimeNow: string = '';
  caption: string = '';
  visibleSection = 'ED';
  profilePic = '../../../../../assets/cameraIcon.png';
  visibleSubSection = "DEG";
  editClicked: boolean = false;
  toggleStatus = "myProfile"; isNotifyBeneficiary: boolean = false;

  beneficiaryId: number = 0;
  educationDetails = [];
  externalBeneficiaryId: any;
  showCropperSection: boolean = true;
  viewMode: boolean = false;
  fileUploadConfigurations = {
    inputMultipleFlag: true,
    fileType: acceptedFileTypes,
    isFileListRequired: true,
    categoryName: 'BENPASSDOC',
    entityId: 0,
    fileCategory: 'PASSCOPY',
    listUploadedFiles: [],
    useCase: 'beneficiary',
    useCaseId: 0,
    documentTypeRequired: true,
    docummentTypeCode: 'BENPASSDOC',
    useEntityId: false,
    isDeleteEnabled: sessionStorage.getItem('bene-profile-viewMode') == 'true' ? false : true,
    isUploadEnabled: sessionStorage.getItem('bene-profile-viewMode') == 'true' ? false : true,
    familyId: null
  };

  observableSubscription$ = new Subject();

  //Sub tabs for Family & Dependent details
  activeIndex = 0;
  presentIndex = 0;
  activeSubIndex = 0;
  presentSubIndex = 0;
  activeRightTabIndex = 0;
  presentRightTabIndex = 0;
  items: any[] = [];
  //Edited by Arun for declaring variables
  maritalStatus: string = '';
  isSelf: boolean = true;
  isEConsent: boolean = false;
  isFamily: boolean = false;
  isDependent: boolean = false;
  isDocuments: boolean = false;
  isBankDetails: boolean = false;
  isW4Details: boolean = false;
  isForm16Details: boolean = false;
  isMyPayslipsDetails: boolean = false;
  isJobDetails: boolean = true;
  isEducation: boolean = false;
  isWorkExperience: boolean = false;
  isImmigration: boolean = false;
  isQuickStart: boolean = false;
  isDocumentsExpirations = false;

  isFinancialsOpen: boolean = false;
  emplId: any;
  selectedDetailAbout: any;
  beneficiaryFamilyInfo: any;
  beneficiarySelfInfo: any;
  familyRelTypeArr: ReferenceLibrary[];
  dependentItems: any[];
  dependentIdSubscription: Subscription;
  dependentId: any;
  beneficiaryType: any;
  familyId: number;
  showOtherDependentSection: boolean = false;
  imageDetails: any;
  showFileUploadSection = false;
  isDirtyCheckedOnTabChanged = false;
  originUrl: string;
  originPage: string;
  beneficiaryProfileUpdate: any;
  beneficiaryProfileExperience: any;
  beneficiaryProfileEducation: any;
  beneUpdateProfile: boolean = false;
  profileEducationUpdate: boolean = true;
  profileUpdate: boolean = true;
  familySection: string = "";
  currentFamilyId: number;
  @ViewChild(HelpVideoOverlayComponent, { static: false }) helpVideoComponent: HelpVideoOverlayComponent;
  showUploadPassport: boolean = true;
  customQuestionnaieDisplay: any;
  dependentRelationshipCode: string | null = null;
  personalDetailsEdit: boolean = false;
  relativeId: string | null;
  onlyFormBuilder;
  companyId;
  fbBeneficiaryId;
  employeeId;
  fbDetails = {
    moduleId: null,
    pageFormId: null
  };
  employeeJobDetails: any;
  isDropBox = true;
  isGoogleDrive = false;
  fileList: any[] = [];
  API_KEY = 'AIzaSyCYpSMpPgO_3wS4egCeqFaQEiUnej1CHnA';
  // API_KEY = 'AIzaSyC7J1Bxv6vP6KU21ZBv6PcUpmNVjAtwOOA';
  SCOPES = 'https://www.googleapis.com/auth/drive.readonly';
  fbEmpId: any;
  currentUserRole: string | null;


  selectedState = 'complete';
  dependentsList:any = [];
  showLifeStoryTimeLineSection: boolean;

  currentIndex = null;
  currentItem='self';
  currentSelectedDependent: any;

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  hasHorizontalScroll: boolean = false;

  constructor(
    private refLibService:ReferenceLibraryService,
    private authenticationService: AuthenticationService,
    private apiService: ApiServicesService,
    private userRoleService: UserRoleService,
    public dialog: MatDialog,
    private uploadDocumentService: UploadDocumentService,
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private referenceLibraryService: ReferenceLibraryService,
    private dependentProfileDataService: DependentProfileDataService,
    public guard: DirtyFormGuard,
    public store: Store<any>,
     public dialogService: DialogService,
    private changeDetectorRef: ChangeDetectorRef, private customQuestionnaireService: CustomQuestionnaireService) {

    const navState = this.router.getCurrentNavigation();
    this.originUrl = (navState.extras && navState.extras.state && navState.extras.state.redirectUrl) ? navState.extras.state.redirectUrl : '';
    this.originPage = (navState.extras && navState.extras.state && navState.extras.state.redirectPage) ? navState.extras.state.redirectPage : '';
    this.originUrl = this.originUrl == '' ? '../list' : this.originUrl; //fall back to list page
    if (sessionStorage.getItem('originPage') && sessionStorage.getItem('originUrl')) {
      this.originPage = sessionStorage.getItem('originPage');
      this.originUrl = sessionStorage.getItem('originUrl');
    }
    //IM-3898
    this.caption = this.router.getCurrentNavigation().extras.state ?
      this.router.getCurrentNavigation().extras.state.profileName : this.caption;

    this.referenceLibraryService.getReferenceData('FAMRELTYP')
      .subscribe(data => {
        this.familyRelTypeArr = data;
        //this.setDependentTabItems();

      });
    //IM-13361 back button
    if (this.originUrl) {
      sessionStorage.setItem('redirectUrl', this.originUrl);
    }
    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationEnd) {
        if (sessionStorage.getItem('bene-update-profile') == 'true') {
          //console.log('Moving Top');
          window.scrollTo(0, 0);
        }
      }
    });
    this.currentUserRole = sessionStorage.getItem('userTypeRole');
    if (sessionStorage.getItem('viewPetitions')) {
      this.toggleStatus = 'myPetitions';
    }
    if (sessionStorage.getItem('viewLCA')) {
      this.toggleStatus = 'myLCA';
    }
    
  }

  ngAfterViewInit() {
      this.translet();    
    this.helpVideoComponent.setValues('right', 'Building Beneficiary Profile', 'Building Beneficiary Profile');
  }

  translet(){
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
      // this.referenceLibraryService.transletConversion().pipe(takeUntil(this.observableSubscription$)).subscribe((response:any) => {
      //   console.log(response);
      // });
    }, 600);  
  }
  

  ngOnInit() {
    this.companyId = parseInt(sessionStorage.getItem('companyId'));
    this.employeeId = parseInt(sessionStorage.getItem('employeeId'));
    if (this.route.snapshot.queryParams.hasOwnProperty('fbEmpId')) {
      this.fbEmpId = this.route.snapshot.queryParams.fbEmpId;
    }
    this.employeeId = sessionStorage.setItem('employeeId', this.employeeId.toString());
    // console.log('thing', this.route.snapshot.queryParams.pageFrom);
    this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;

    gapi.load('client:auth2', () => this.initClient());
    let tab = this.route.snapshot.queryParamMap.get('tab');
    if (tab == 'dropbox') {
      this.toggleMode('cloudstorage');
      this.showDropbox();
    }

    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
      this.getFBDetails();
    }
    else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }

    this.beneficiaryProfileUpdate = sessionStorage.getItem('bene-update-profile'); //bene-update-profile
    this.viewMode = sessionStorage.getItem('bene-profile-viewMode') == 'true' ? true : false;
    //IM-3763-Profile picture is not shown when Petitioner edits beneficiary.
    // this.userRoleService.profilePicUpdate.subscribe((hasImage: boolean) => {
    //   this.profilePic = hasImage ? `data:image/jpeg;base64,${sessionStorage.getItem('profilePic')}` : '../../../../../assets/cameraIcon.png';
    // });
    this.userRoleService.profilePicUpdate.subscribe((obj: any) => {
      this.profilePic = obj.hasImage ? `data:image/jpeg;base64,${obj.image}` : '../../../../../assets/cameraIcon.png';
    });
    this.dependentIdSubscription = this.dependentProfileDataService.dependentProfileSubject.subscribe(selectedBeneObj => {
 
      this.familyId = selectedBeneObj.dependentId;
      this.beneficiaryType = selectedBeneObj.beneficiaryType;
      this.showFileUploadSection = (this.beneficiaryType === 'family' && this.familyId) ? true : (this.beneficiaryType === 'self') ? true : false;
      this.getUpolodedFiles();

    });
    // if (this.onlyFormBuilder !== 'FB' && this.beneficiaryId !== null) {
    this.dependentProfileDataService.selfBeneficiaryDetailChange.subscribe(() => {
      this.getBeneficiarySelfDetails();
      // this.getBeneficiaryFamilyDetails();
      //this.setDependentDynamicTabs(this.beneficiaryFamilyInfo);
    });
    // }
    this.dependentProfileDataService.newSubDependentCreated.subscribe((response) => {
      this.setDependentDynamicTabs(response.beneficiaryFamilyInfo);
      this.modifyItemsArr();
      const item = this.dependentItems.find(x => x.subTabsList && x.subTabsList.length > 0 && x.subTabsList.some(y => y.id == response.selectedSubTabId));
      this.setSelectedDetailAbout(item, response.selectedSubTabId);
    });
    // this.getEducationDetails();
    // this.getUpolodedFiles();
    this.fileUploadConfigurations.entityId = this.beneficiaryId;
    this.fileUploadConfigurations.useCaseId = this.beneficiaryId;
    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
    if (this.viewMode) {
      this.apiService.getBeneficiaryDetails(this.beneficiaryId, 'self').subscribe((beneficiary: BeneficiaryDetails) => {
        this.caption = beneficiary.fName + "'s Profile";
      });
    }
    else {
      this.caption = this.caption == '' ? "My Profile" : this.caption;
    }
    this.getBeneficiarySelfDetails();
    this.getBeneficiaryFamilyDetails();
    //this.dependentProfilesubscription = this.dependentProfileDataService.currentMessage.subscribe(message => this.message = message)
    this.selectedDetailAbout = {
      showDetailFor: 'self',
    };
    this.familySection = sessionStorage.getItem('navigationFamilySection');
    this.dependentRelationshipCode = sessionStorage.getItem('relationshipCode');
    this.relativeId = sessionStorage.getItem('relativeId')
    if (this.familySection) {
      this.setDependentTabItems();
      this.isSelf = true;
      this.isEConsent = false;
      this.isDocuments = false;
      this.isEducation = false;
      this.isWorkExperience = false;
      this.isImmigration = false;
      this.isBankDetails = false;
      this.isW4Details = false;
      this.isForm16Details = false;
      this.isMyPayslipsDetails = false;
      this.isFamily = (this.dependentRelationshipCode && ['CHILD', 'SPOUSE'].includes(this.dependentRelationshipCode) ? true : false);
      this.isDependent = true;
      this.showOtherDependentSection = (this.dependentRelationshipCode && !['CHILD', 'SPOUSE'].includes(this.dependentRelationshipCode) ? true : false);
      this.activeRightTabIndex = this.isFamily || this.maritalStatus === 'SNGL' ? 1 : 2;
      this.modifyItemsArr();
      this.selectedDetailAbout = {
        showDetailFor: 'dependent',
        dependentType: this.dependentRelationshipCode && this.dependentItems.length ? (this.dependentItems.filter((item) => item.code === this.dependentRelationshipCode)[0]) : this.dependentItems[0],
        selectedSubTabId: null
      }
      this.getBeneDetailsLibrary();
      if (this.relativeId) {
        this.familyId = parseInt(this.relativeId);
        this.dependentProfileDataService.changeDependentProfileID(this.familyId, 'family');
      }
      sessionStorage.removeItem('navigationFamilySection');
      sessionStorage.removeItem('relationshipCode');
      sessionStorage.removeItem('relativeId');
    }
    if (this.currentUserRole === 'Beneficiary') {
      this.isNotifyBeneficiary = false;
    } else {
      this.isNotifyBeneficiary = true;
    }
    localStorage.setItem("currentUserSelection", JSON.stringify(this.selectedDetailAbout));
    //this.getQuestionsList();
    this.loadDependents();
    this.handleCustomTabChange(null,null);
  }

  loadDependents(){
    this.apiService.getDependentList(this.beneficiaryId)
    .subscribe(data => {
      this.dependentsList = data;
      this.dependentsList.map(x=>x.fullName = x.firstName+' '+x.lastName);
      if(this.dependentsList.length>4){
        this.hasHorizontalScroll = true;
      } else {
        this.hasHorizontalScroll = false;
      }
      this.translet();
    });
  }

  getQuestionsList() {
    if (this.onlyFormBuilder !== 'FB' && this.beneficiaryId !== null) {
      if (parseInt(sessionStorage.getItem('companyId'))) {
        const customQuesData = {
          companyId: parseInt(sessionStorage.getItem('companyId')),
          beneficiaryId: this.beneficiaryId
        };
        this.customQuestionnaireService.getCustomJsonList(customQuesData).subscribe((data) => {
          if (data) {
            this.customQuestionnaieDisplay = data;
            localStorage.setItem('customQuestions', JSON.stringify(this.customQuestionnaieDisplay));
          }
        });
      }
    }
  }

  getFBDetails() {
    this.employeeId = parseInt(sessionStorage.getItem('employeeId'));
    this.apiService.getFBEmployeeDetails(this.fbEmpId).subscribe((data: any) => {
      this.fbDetails = data;
      this.fbDetails = {
        moduleId: this.fbDetails.moduleId,
        pageFormId: this.fbDetails.pageFormId
      }
      // this.beneficiaryId = this.fbBeneficiaryId ? this.fbBeneficiaryId : 0;
      this.apiService.getEmployeeFBDetails(this.fbDetails.moduleId, this.fbDetails.pageFormId, this.companyId, this.beneficiaryId).pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiarySelfInfo: any) => {
        this.beneficiarySelfInfo = beneficiarySelfInfo;
        this.externalBeneficiaryId = beneficiarySelfInfo.id;
        this.maritalStatus = this.beneficiarySelfInfo.maritalStatus && this.beneficiarySelfInfo.maritalStatus.code ? this.beneficiarySelfInfo.maritalStatus.code : null;
        this.showOtherDependentSection = (this.beneficiarySelfInfo.ctznshipCountryCode && this.beneficiarySelfInfo.ctznshipCountryCode.countryCode && this.beneficiarySelfInfo.ctznshipCountryCode.countryCode === 'USA') || (this.beneficiarySelfInfo.isLpr) ? true : false;
      });
    })
  }

  getBeneDetailsLibrary() {
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
    if (this.beneficiaryProfileUpdate === 'true' || (sessionStorage.getItem('listBeneficiaryId') && sessionStorage.getItem('relativeId'))) {   //beneficiaryId
      this.profileEducationUpdate = false;
      this.profileUpdate = true;
    } else {
      this.profileEducationUpdate = true;
      this.profileUpdate = false;
    }
  }
  personalDetails(param) {
    if (!this.caption) {
      this.caption = param.fName + "'s Profile";
      this.getBeneDetailsLibrary();
    }
  }

  backToOriginPage() {
    this.router.navigate([`${this.originUrl}`], { relativeTo: this.route });
  }

  toggleFinancials() {
    this.isFinancialsOpen = !this.isFinancialsOpen;
    this.cdr.detectChanges();
    this.setAccordionContentStyle('none');
  }

  setAccordionContentStyle(display: string) {
    const accordionContent = this.el.nativeElement.querySelectorAll('.bankdetails .p-accordion-content, .w4details .p-accordion-content, .form16details .my_payslips .p-accordion-content');
    accordionContent.forEach(content => {
      this.renderer.setStyle(content, 'display', display);
    });
  }
  setDependentTabItems() {
    //This value hard coded bcoz to show tab as per UX
    this.items = [
      {
        header: 'Fiance',
        content: 'content1',
        code: "FIANCE",
        desc: "Fiance",
        group: "FAMRELTYP",
        id: 1110,
        name: "Fiance",
        subTabsList: null
      },
      {
        header: 'Father',
        content: 'content1',
        code: "FATHER",
        desc: "Father",
        group: "FAMRELTYP",
        id: 15,
        name: "Father",
        subTabsList: null
      },
      {
        header: 'Mother', content: 'content1', code: "MOTHER",
        desc: "Mother",
        group: "FAMRELTYP",
        id: 16,
        name: "Mother",
        subTabsList: null
      },
      {
        header: 'Sister', content: 'content1', code: "SISTER",
        desc: "Sister",
        group: "FAMRELTYP",
        id: 889,
        name: "Sister",
        subTabsList: []
      }, {
        header: 'Brother', content: 'content1', code: "BROTHER",
        desc: "Brother",
        group: "FAMRELTYP",
        id: 888,
        name: "Brother",
        subTabsList: []
      },
      {
        header: 'Spouse',
        content: 'content1',
        code: "SPOUSE",
        desc: "Spouse",
        group: "FAMRELTYP",
        id: 14,
        name: "Spouse",
        subTabsList: null
      },
      {
        header: 'Children', content: 'content1',
        code: "CHILD",
        desc: "Child",
        group: "FAMRELTYP",
        id: 13,
        name: "Child",
        subTabsList: [
        ]
      }];


  }

  modifyItemsArr() {
    this.dependentItems = [];
    if (this.isFamily) {
      let familyItems = ['SPOUSE', 'CHILD'];
      this.dependentItems = this.items.filter(item => familyItems.includes(item.code));
    } else {
      if (this.showOtherDependentSection) {
        this.dependentItems = this.items.filter(item => ['FIANCE', 'FATHER', 'MOTHER', 'SISTER', 'BROTHER'].includes(item.code));
      } else {
        this.dependentItems = this.items.filter(item => ['FATHER', 'MOTHER'].includes(item.code));
      }

    }

  }

  setComponentVisibility(section) {
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
    this.visibleSection = section;
  }

  onEditClicked(status) {
    this.editClicked = status;
    if (status) {
      this.fileUploadConfigurations.isDeleteEnabled = true;
      this.fileUploadConfigurations.isUploadEnabled = true;
    }
    this.getUpolodedFiles();
  }

  onHasPassportChange(flag: boolean) {
    this.showUploadPassport = flag;
  }

  getEducationDetails() {
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
    this.apiService.getEducationDetails(this.beneficiaryId).pipe(takeUntil(this.observableSubscription$))
      .subscribe(data => {
        if (data['status'] === 200) {
          this.educationDetails = data['data']['education'];
        }

      });
  }

  dataURItoBlob(dataURI) {
    const binary = atob(dataURI.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: 'image/png',
    });
  }

  uploadProfile() {
    this.showCropperSection = false;
    let employeeId = parseInt(sessionStorage.getItem('employeeId'));

    const dialogRef = this.dialog.open(ProfilePictureUploadComponent, {
      panelClass: 'custom-dialog',
      height: '435px',
      width: '520px'
    });

    dialogRef.afterClosed().subscribe(result => {
      let profileImage = result;
      const file = this.dataURItoBlob(result);
      let fd = new FormData();
      fd.append("file", file, "myprofile.png");
      this.apiService.updateProfilePic(this.beneficiaryId, fd).subscribe((response) => {
        if (response['status'] === 200) {
          this.profilePic = `data:image/jpeg;base64,${response['data']['profilePic']}`;
          sessionStorage.setItem('profilePic', response['data']['profilePic']);
          sessionStorage.setItem('avatar', response['data']['smalPprofilePic']);
          let noUpdateFlag = sessionStorage.getItem('FbEmployeeId') !== sessionStorage.getItem('beneficiaryId') ? true : false;
          this.userRoleService.imageProfileUpdated(noUpdateFlag);
          this.toastr.success('Profile Pic Uploaded successfully', 'Success');
        }
        else {
          CustomErrorToastComponent.showErrorToast(this.toastr, 'Profile Pic Upload Failed!');
        }
      });

    });
  }

  getUpolodedFiles() {
    this.fileUploadConfigurations.familyId = this.familyId ? this.familyId : null;
    this.currentFamilyId = this.fileUploadConfigurations.familyId;
    this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
    //this.editClicked =  (sessionStorage.getItem('dependentId') == '0') ? false : true
    this.uploadDocumentService.genericGetUploadDocument(this.fileUploadConfigurations.useCase, this.fileUploadConfigurations.useCaseId, this.fileUploadConfigurations.categoryName, this.fileUploadConfigurations.entityId, this.fileUploadConfigurations.useEntityId, this.fileUploadConfigurations.familyId).subscribe((response) => {
      if (response['status'] === 200) {
        this.fileUploadConfigurations.listUploadedFiles = response['data'];
        this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
      }
      else {
        this.fileUploadConfigurations.listUploadedFiles = [];
        this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
      }
    });
  }

  ngOnDestroy() {
    sessionStorage.removeItem('newFamilyId');
    if (this.dependentIdSubscription) {
      this.dependentIdSubscription.unsubscribe();
    }
    if (!(this.router.routerState.snapshot.url.indexOf('profile/profile-details') > -1)) {
      sessionStorage.removeItem('bene-profile-viewMode');
      sessionStorage.removeItem('listBeneficiaryId');
      sessionStorage.removeItem('beneficiaryTypeExp');
      sessionStorage.removeItem('beneficiaryIdExp');
    }
  }

  onTabOpen(index: any, event: any) {
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
      this.getFBDetails();
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
    this.getQuestionsList();
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        if (this.onlyFormBuilder === 'FB') {
          this.router.navigate(['../profile/profile-details'], { relativeTo: this.route, queryParams: { pageFrom: 'FB', fbEmpId: this.fbEmpId } });
        } else {
          this.router.navigate(['../profile/profile-details'], { relativeTo: this.route });
        }

        this.presentRightTabIndex = index;
        this.currentInfo();
        switch (event) {
          // case 'QUICK START':
          //   this.isQuickStart = true;
          //   this.isSelf = false;
          //   this.isDocuments = false;
          //   this.isEducation = false;
          //   this.isWorkExperience = false;
          //   this.isImmigration = false;
          //   this.isEConsent = false;
          //   this.isJobDetails = false;
          //   this.isBankDetails = false;
          //   this.isW4Details = false;
          //   this.isForm16Details = false;
          //   this.isMyPayslipsDetails = false;
          //   this.isDocumentsExpirations = false;
          //   break;
          case 'E-CONSENT':
            this.isQuickStart = false;
            this.isSelf = false;
            this.isDocuments = false;
            this.isEducation = false;
            this.isWorkExperience = false;
            this.isImmigration = false;
            this.isEConsent = true;
            this.isJobDetails = false;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            break;
          case 'EDUCATION':
            this.isQuickStart = false;
            this.isSelf = false;
            this.isDocuments = false;
            this.isEducation = true;
            this.isWorkExperience = false;
            this.isImmigration = false;
            this.isEConsent = false;
            this.isJobDetails = false;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            this.router.navigate(['../profile/education'], { relativeTo: this.route });
            break;
          case 'WORK-EXPERIENCE':
            this.isQuickStart = false;
            this.isSelf = false;
            this.isDocuments = false;
            this.isEducation = false;
            this.isImmigration = false;
            this.isWorkExperience = true;
            this.isEConsent = false;
            this.isJobDetails = true;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.dependentIdSubscription = this.dependentProfileDataService.dependentProfileSubject.pipe(takeUntil(this.observableSubscription$)).subscribe((selectedBeneObj:any) => {
              this.familyId = selectedBeneObj.dependentId;
              this.beneficiaryType = selectedBeneObj.beneficiaryType;
              this.showLifeStoryTimeLineSection = (this.beneficiaryType === 'family' && this.familyId) ? true : (this.beneficiaryType === 'self') ? true : false;
            });
            this.dependentProfileDataService.onLifeStorySubTabs.next();
            this.router.navigate(['../profile/work-experience'], { relativeTo: this.route });
            break;
          case 'IMMIGRATION':
            this.isQuickStart = false;
            this.isSelf = false;
            this.isDocuments = false;
            this.isEducation = false;
            this.isWorkExperience = false;
            this.isImmigration = true;
            this.isEConsent = false;
            this.isJobDetails = true;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            this.router.navigate(['../profile/immigration'], { relativeTo: this.route });
            break;
          case 'DOCUMENTS-LIST':
            this.isQuickStart = false;
            this.isSelf = false;
            this.isDocuments = true;
            this.isEducation = false;
            this.isWorkExperience = false;
            this.isImmigration = false;
            this.isEConsent = false;
            this.isJobDetails = true;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            break;
          case 'DOCUMENTS-EXPIRATIONS':
            this.isSelf = false;
            this.isDocuments = false;
            this.isEducation = false;
            this.isWorkExperience = false;
            this.isImmigration = false;
            this.isEConsent = false;
            this.isJobDetails = false;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = true;
            break;
          case 'BANK DETAILS':
            this.isQuickStart = false;
            this.isSelf = true;
            this.isJobDetails = false;
            this.isEducation = false;
            this.isImmigration = false;
            this.isWorkExperience = false;
            this.isBankDetails = true;
            this.isDocuments = false;
            this.isEConsent = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            break;
          case 'W4 DETAILS(OPTIONAL)':
            this.isQuickStart = false;
            this.isSelf = true;
            this.isJobDetails = false;
            this.isEducation = false;
            this.isImmigration = false;
            this.isWorkExperience = false;
            this.isW4Details = true;
            this.isBankDetails = false;
            this.isDocuments = false;
            this.isEConsent = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            break;
          case 'STATUTORY DETAILS(OPTIONAL)':
            this.isQuickStart = false;
            this.isSelf = false;
            this.isJobDetails = false;
            this.isForm16Details = true;
            this.isBankDetails = false;
            this.isEducation = false;
            this.isImmigration = false;
            this.isWorkExperience = false;
            this.isDocuments = false;
            this.isEConsent = false;
            this.isW4Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            break;
          case 'PAYSLIPS':
            this.isQuickStart = false;
            this.isSelf = false;
            this.isJobDetails = false;
            this.isForm16Details = false;
            this.isBankDetails = false;
            this.isEducation = false;
            this.isImmigration = false;
            this.isWorkExperience = false;
            this.isDocuments = false;
            this.isEConsent = false;
            this.isW4Details = false;
            this.isMyPayslipsDetails = true;
            this.isDocumentsExpirations = false;
            break;
          case 'Family Details':
            this.isQuickStart = false;
            this.isSelf = true;
            this.isJobDetails = true;
            this.isEducation = false;
            this.isImmigration = false;
            this.isWorkExperience = false;
            this.isDocuments = false;
            this.isWorkExperience = false;
            this.isEConsent = false;
            this.isFamily = true;
            this.isDependent = true;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            this.modifyItemsArr();
            //  this.items = this.familyItems;
            this.selectedDetailAbout = {
              showDetailFor: 'dependent',
              dependentType: this.dependentItems[0],
              selectedSubTabId: null
            }
            break;
          case 'Other Dependents Details':
            //  this.items = this.dependentItems;
            this.isQuickStart = false;
            this.isSelf = true;
            this.isJobDetails = true;
            this.isEducation = false;
            this.isImmigration = false;
            this.isDocuments = false;
            this.isWorkExperience = false;
            this.isEConsent = false;
            this.isFamily = false;
            this.isDependent = true;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            this.modifyItemsArr();
            this.selectedDetailAbout = {
              showDetailFor: 'dependent',
              dependentType: this.dependentItems[0],
              selectedSubTabId: null
            }
            break;
          default:
            this.isQuickStart = false;
            this.isSelf = true;
            this.isJobDetails = true;
            this.isEducation = false;
            this.isImmigration = false;
            this.isDocuments = false;
            this.isWorkExperience = false;
            this.isEConsent = false;
            this.isBankDetails = false;
            this.isW4Details = false;
            this.isForm16Details = false;
            this.isMyPayslipsDetails = false;
            this.isDocumentsExpirations = false;
            this.isFamily = false;
            this.isDependent = false;
            this.router.navigate(['../profile/personal'], { relativeTo: this.route });
            break;
        }

        localStorage.setItem("currentUserSelection", JSON.stringify(this.selectedDetailAbout));
      }
      else {
        this.changeDetectorRef.detectChanges();
        this.activeRightTabIndex = this.presentRightTabIndex;
        return false;
      }
    });
  }

  currentInfo(){
    if(this.currentItem == 'family'){
      sessionStorage.setItem('newFamilyId', this.currentSelectedDependent?.id);
      this.dependentProfileDataService.dependentProfileSubject.next({
        dependentId: this.currentSelectedDependent?.id,
        beneficiaryType: 'family'
      });
    } else {
      sessionStorage.removeItem('newFamilyId');
      this.dependentProfileDataService.dependentProfileSubject.next({
        dependentId: null,
        beneficiaryType: 'self'
      });
    }
  }

  handleTabChange(e) {
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
    this.getQuestionsList();

    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        const selectedDependentTab: any = this.dependentItems[e.index];
        this.router.navigate(['../profile/profile-details'], { relativeTo: this.route });
        this.presentIndex = e.index;
        this.presentSubIndex = this.activeSubIndex = 0;
        this.selectedDetailAbout = {
          showDetailFor: 'dependent',
          dependentType: selectedDependentTab,
          selectedSubTabId: selectedDependentTab && selectedDependentTab.subTabsList && selectedDependentTab.subTabsList.length ? selectedDependentTab.subTabsList[0].id : null
        }

      } else {
        this.changeDetectorRef.detectChanges();
        this.activeIndex = this.presentIndex;
        return false;
      }
    });
  }

  handleCustomTabChange(item, index){
    if(index!==null){
      this.currentIndex = index;
      this.currentItem = 'family';
    } else {
      this.currentIndex = null;
      this.currentItem = 'self';
    }
    if(this.currentItem=='self'){
      this.selectedDetailAbout = {
        showDetailFor: 'self',
        dependentType: null,
        selectedSubTabId: null
      };
      // this.personalDetailsEdit = true;
      this.onTabOpen(0,"PERSONAL INFO");
      this.activeRightTabIndex = 0;
    } else {
      if (this.onlyFormBuilder !== 'FB' && this.beneficiaryId !== null) {
        this.apiService.getBeneficiaryDetails(this.beneficiaryId, this.currentItem).pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiaryFamilyInfo: any) => {
          const selectedDependent = beneficiaryFamilyInfo.find(x=>x.id==item.id);
          this.currentSelectedDependent = selectedDependent;
          this.selectedDetailAbout = {
            isNewImplementation: true,
            showDetailFor: 'dependent',
            dependentType: this.currentItem == 'family' ? selectedDependent : null
          }
          // this.personalDetailsEdit = true;
          this.onTabOpen(0,"PERSONAL INFO");
          this.activeRightTabIndex = 0;
        }); 
      }
    }
    this.translet();
   
  }

  handleSubTabChange(e, item) {
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
    this.router.navigate(['../profile/profile-details'], { relativeTo: this.route });
    this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
        this.presentSubIndex = e.index;
        this.setSelectedDetailAbout(item, item.subTabsList[e.index].id);
      }
      else {
        this.changeDetectorRef.detectChanges();
        this.activeSubIndex = this.presentSubIndex;
        return false;
      }
    });

  }

  onRefreshPage(event) {
    if (event) {
      this.getQuestionsList();
    }
  }

  setSelectedDetailAbout(item, selectedSubTabId) {
    this.selectedDetailAbout = {
      showDetailFor: 'dependent',
      dependentType: item,
      selectedSubTabId
    };
    this.currentFamilyId = parseInt(this.selectedDetailAbout.selectedSubTabId) !== 0 ? parseInt(this.selectedDetailAbout.selectedSubTabId) : null;
  }

  addSubTabs(mainTab) {
    let len = mainTab.subTabsList.length;
    mainTab.subTabsList.splice(mainTab.subTabsList.length, 0, { header: `${mainTab.name} ${mainTab.subTabsList.length + 1}`, content: '', id: 0, showButton: false });
    if (mainTab.subTabsList.length > len) {
      setTimeout(() => {
        this.presentSubIndex = this.activeSubIndex = mainTab.subTabsList.length - 1;
        this.setSelectedDetailAbout(mainTab, mainTab.subTabsList[this.activeSubIndex].id);
      }, 0);
    }
  }



  getBeneficiarySelfDetails() {
    if (this.onlyFormBuilder !== 'FB' && this.beneficiaryId !== null) {
      this.apiService.getBeneficiaryDetails(this.beneficiaryId, 'self').pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiarySelfInfo: any) => {
        this.beneficiarySelfInfo = beneficiarySelfInfo;
        this.externalBeneficiaryId = beneficiarySelfInfo.id;
        this.maritalStatus = this.beneficiarySelfInfo.maritalStatus && this.beneficiarySelfInfo.maritalStatus.code ? this.beneficiarySelfInfo.maritalStatus.code : null;
        this.showOtherDependentSection = (this.beneficiarySelfInfo.ctznshipCountryCode && this.beneficiarySelfInfo.ctznshipCountryCode.countryCode && this.beneficiarySelfInfo.ctznshipCountryCode.countryCode === 'USA') || (this.beneficiarySelfInfo.isLpr) ? true : false;
        this.benefirstAndLastName = beneficiarySelfInfo?.firstAndLastName || '';
      });
    }
  }

  getEmployeeJobDetails() {
    if (this.onlyFormBuilder === 'FB') {
      this.beneficiaryId = (sessionStorage.getItem('FbEmployeeId')) ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 0;
    } else {
      this.beneficiaryId = (sessionStorage.getItem('listBeneficiaryId')) ? parseInt(sessionStorage.getItem('listBeneficiaryId')) : this.authenticationService.currentUserValue['beneficiaryId'];
    }
    this.apiService.getEmployeeJobDetails(this.beneficiaryId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response.status === 200) {
        this.employeeJobDetails = response.data;
      }
    })
  }


  getBeneficiaryFamilyDetails() {
    if (this.onlyFormBuilder !== 'FB' && this.beneficiaryId !== null) {
      this.apiService.getBeneficiaryDetails(this.beneficiaryId, 'family').pipe(takeUntil(this.observableSubscription$)).subscribe((beneficiaryFamilyInfo: any) => {
        this.beneficiaryFamilyInfo = beneficiaryFamilyInfo;
        this.setDependentDynamicTabs(beneficiaryFamilyInfo);
      });
    }
  }

  setDependentDynamicTabs(beneficiaryFamilyInfo) {
    this.beneficiaryFamilyInfo = beneficiaryFamilyInfo;
    this.imageDetails = this.beneficiaryFamilyInfo;


    this.items.forEach((item) => {
      if (item && item.subTabsList) {
        item.subTabsList = [];
        if (this.beneficiaryFamilyInfo && this.beneficiaryFamilyInfo.length > 0) {
          this.beneficiaryFamilyInfo.forEach((familyItem) => {
            if (familyItem.relationShipType.code === item.code) {
              item.subTabsList.splice(item.subTabsList.length, 0, { header: `${item.name} ${item.subTabsList.length + 1}`, content: '', id: `${familyItem.id}`, showButton: false });
            }
          });
        }
        if (item.subTabsList.length === 0) {
          item.subTabsList.splice(item.subTabsList.length, 0, { header: `${item.name} ${item.subTabsList.length + 1}`, content: '', id: 0, showButton: false });
        }
      }
    });
    // }
    if (this.dependentRelationshipCode && this.dependentRelationshipCode !== 'SPOUSE' && this.beneficiaryFamilyInfo && this.beneficiaryFamilyInfo.length > 0) {
      this.activeRightTabIndex = this.isFamily || this.maritalStatus === 'SNGL' || (!this.isFamily && !this.maritalStatus && this.dependentRelationshipCode) ? 1 : 2;
      let subIndex = this.dependentItems.findIndex((item) => item.code === this.dependentRelationshipCode);
      this.activeIndex = this.presentIndex = subIndex;
      if (this.relativeId && this.dependentItems[subIndex].subTabsList) {
        if (!this.dependentItems[subIndex].subTabsList.length && this.items.length) {
          this.dependentItems[subIndex].subTabsList = this.items.filter((item) => item.code === this.dependentRelationshipCode)[0].subTabsList;
        }
        this.activeSubIndex = this.dependentItems[subIndex].subTabsList.findIndex((item) => item.id === this.relativeId);
        const activeSubTabId = this.activeSubIndex > -1 ? this.dependentItems[subIndex].subTabsList[this.activeSubIndex].id : this.dependentItems[subIndex].subTabsList[0].id;
        //this.dependentProfileDataService.changeDependentProfileID(this.familyId, this.dependentRelationshipCode);
        this.setSelectedDetailAbout(this.dependentItems[subIndex], activeSubTabId);
      }
      this.personalDetailsEdit = (this.beneficiaryProfileUpdate == 'true');
    }
  }

  deleteDocumentHandler(item) {
    this.apiService.deleteFileFromDocumentList(this.beneficiaryId, item.fileCategory.group, item.fileCategory.code, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {
      //  console.log("data",data);

      this.toastr.success(data.message, 'Success');
    });
  }

  deleteBankDocumentHandler(item) {
    this.apiService.deleteBankFileFromDocumentList(item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {
      this.toastr.success(data.message, 'Success');
    });
  }

  deleteW4DocumentHandler(item) {
    if (item.fileCategory === 'Federal W4') {
      this.apiService.deleteW4FileFromDocumentList(this.beneficiaryId, 'W4FORMS', 'FEDE').pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {
        this.toastr.success(data.message, 'Success');
      });
    } else if (item.fileCategory === 'State W4') {
      this.apiService.deleteW4FileFromDocumentList(this.beneficiaryId, 'W4FORMSSTATE', 'STAT').pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {
        this.toastr.success(data.message, 'Success');
      });
    }
  }

  deleteForm16DocumentHandler(item) {
    this.apiService.deleteForm16FileFromDocumentList(this.beneficiaryId).pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {
      this.toastr.success(data.message, 'Success');
    });
  }

  toggleMode(mode) {
    this.toggleStatus = mode;
    this.getEmployeeJobDetails();
    if (mode === 'myProfile' || mode === 'jobSummary') {
      this.activeRightTabIndex = 0;
      this.isJobDetails = true;
      this.isSelf = true;
      this.isBankDetails = false;
      this.isW4Details = false;
      this.isDocuments = false;
      this.isEConsent = false;
      this.isEducation = false;
    }
  }

  showDropbox() {
    this.isDropBox = true;
    this.isGoogleDrive = false;
  }

  showGoogleDrive() {
    this.isGoogleDrive = true;
    this.isDropBox = false;
  }
  initClient() {

    gapi.client.init({
      //redirect_uri:"http://localhost:4300/beneficiary-landing/beneficiaries/profile/profile-details?tab=googledrive",
      apiKey: this.API_KEY,
      clientId: '674135747348-nqn8fquekok8tmhbnsapgd6s5oquie5m.apps.googleusercontent.com',
      discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
      scope: this.SCOPES
    }).then(() => {
      // Set up sign-in event listener
      document.getElementById('drive-auth').addEventListener('click', () => this.handleAuthClick());
      document.getElementById('drive-list').addEventListener('click', () => this.listFiles());
    }, (error: any) => {
      //console.error('Error initializing Google Drive API:', error);
    });
  }
  // Handle the sign-in event
  handleAuthClick() {
    gapi.auth2.getAuthInstance().signIn().then(() => this.loadDriveAPI());
  }
  // Load the Google Drive API
  loadDriveAPI() {
    gapi.client.setApiKey(this.API_KEY);
    return gapi.client.load('drive', 'v3');
  }
  // Retrieve the list of files from Google Drive
  listFiles() {
    gapi.client.drive.files.list({
      'pageSize': 10, // Number of files to retrieve per page
      // 'fields': 'nextPageToken, files(name, webViewLink, webContentLink)' // Specify the fields to include in the response
      // 'fields': 'nextPageToken' // Specify the fields to include in the response
    }).then((response: any) => {
      this.fileList = response.result.files;
      //console.log('Google>>>',  this.fileList);
    }, (error: any) => {
      //console.error('Error retrieving files:', error);
    });
  }

  onChange($event) {
    this.selectedState = $event.value;
    if (this.selectedState === 'complete') {
      this.redirectToProfile();
    }
  }

  redirectToProfile() {
    this.router.navigate(['../profile/profile-details'], { state: { profileName: this.caption, redirectUrl: '../list', redirectPage: 'Back to beneficiary List' }, relativeTo: this.route });
  }

  addMembers() {
    const dynamicDialogRef = this.dialogService.open(AddBeneficiaryOrMemberComponent, {
      width: '60%',
      height: 'auto',
      contentStyle: { 'z-index': '1000', 'padding-bottom': '15px', 'overflow-y': 'hidden !important' },
      styleClass: 'create-task-new-dialog',
      closable: false,
      showHeader: false,
      closeOnEscape: false,
      modal: true,
      dismissableMask: true,
      data: {isAddingMember: true, beneficiaryId: this.beneficiaryId, isBeneficiaryInitiated:true}
    });   
    dynamicDialogRef.onClose.subscribe( data=> {
       console.log(data);
       this.loadDependents();
    });
  }


  scrollRight() {
    this.scrollContainer.nativeElement.scrollTo({ left: (this.scrollContainer.nativeElement.scrollLeft + 150), behavior: 'smooth' });
  }

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollTo({ left: (this.scrollContainer.nativeElement.scrollLeft - 150), behavior: 'smooth' });
  }
  
}
